module.exports = __webpack_public_path__ + "static/media/image_74.e996dde5.png";